import { IGetAuthDataResult } from './parseAuthData';
import { setAccessToken } from './accessToken';
import { setRefreshToken } from './refreshToken';
import { setExpiryTime } from './expiryTime';

const setAuthData = async ({
  accessToken,
  refreshToken,
  expiryTime,
  isIdentifyToken = false,
}: IGetAuthDataResult & { isIdentifyToken?: boolean }) => {
  await setAccessToken(accessToken, isIdentifyToken);
  setRefreshToken(refreshToken);
  setExpiryTime(expiryTime);
};

export default setAuthData;
